module.exports = __webpack_public_path__ + "static/goblins_band-548eff5ff18afe374b01892893cf3d3f.jpg";